module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('a', {
    staticClass: "left",
    attrs: {
      "href": _vm.story.url
    }
  }, [_vm._v(_vm._s(_vm.story.id))]), _vm._v(" "), _c('span', {
    class: _vm.cardGlyph(_vm.story)
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.story.estimate),
      expression: "story.estimate"
    }],
    staticClass: "right badge badge-primary"
  }, [_vm._v(_vm._s(_vm.story.estimate))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.story.estimate),
      expression: "!story.estimate"
    }],
    staticClass: "right badge badge-primary"
  }, [_vm._v("-")])]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.story.name))]), _vm._v(" "), _c('div')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e723abce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoryCard.vue
// module id = 153
// module chunks = 1